import { z } from "zod";

/** Represents the enum public.template_type */
type TemplateType = "email" | "sms" | "push_notification" | "document";

export default TemplateType;

/** Zod schema for template_type */
export const templateType = z.enum(["email", "sms", "push_notification", "document"]);
